import { createFileRoute } from '@tanstack/react-router';
import { AdminSupportPage } from '@/components/admin/admin-support';

export const Route = createFileRoute('/admin/support')({
  component: AdminSupportPage,
});
